import React, { useEffect, useState } from "react";
import DefaultImageCard from "../images/defaultImageCard.png";
import { useParams } from "react-router-dom";

function SiteCardWithDetail(props) {
  const { lang } = useParams();
  const [detailSite, setDetailSite] = useState(null);
  useEffect(() => {
    if (props.detailSite) {
      setDetailSite(props.detailSite);
    }
  }, [props.detailSite]);

  function onClickActiveSiteCard() {
    if (!detailSite) return;

    let detail = {
      ...detailSite,
    };
    detail.Active = !detail.Active;
    setDetailSite(detail);

    try {
      props.onToggle(detail);
    } catch {}
  }

  const getDetailSiteName = detailSite?.Name.includes('"name_english"')
    ? JSON.parse(detailSite?.Name)
    : detailSite?.Name;

  const detailSiteName =
    typeof getDetailSiteName === "string"
      ? getDetailSiteName
      : lang === "th"
      ? getDetailSiteName?.name_thai
      : getDetailSiteName?.name_english;

  return (
    <div className="flex items-center w-full mb-3 h-14">
      <div className="overflow-hidden rounded-lg w-14 h-14 bg-vekin-primary/30">
        {!detailSite?.Image.includes("data:") ? (
          <img
            className="w-full h-full object-cover"
            src={detailSite?.Image}
            alt=""
          />
        ) : (
          <img
            className="w-full h-full object-cover"
            src={DefaultImageCard}
            alt=""
          />
        )}
      </div>
      <div className="h-full mx-2" style={{ width: "calc(100% - 126px" }}>
        <p
          className="w-full mb-px overflow-hidden text-sm font-bold text-vekin-primary text-ellipsis whitespace-nowrap"
          title={detailSiteName}
        >
          {detailSiteName}
        </p>
        <p className="inline-block w-full overflow-hidden text-xs font-normal leading-tight whitespace-normal text-primary text-ellipsis line-clamp-2">
          {detailSite?.Description.includes("null") ||
          detailSite?.Description.includes("undefined")
            ? " "
            : detailSite?.Description}
        </p>
      </div>
      <div
        className={`toggle-box ${detailSite?.Active ? "active" : "inactive"}`}
        onClick={(e) => {
          onClickActiveSiteCard();
        }}
      >
        <div
          className={`toggle-thumb ${
            detailSite?.Active ? "active" : "inactive"
          }`}
        ></div>
      </div>
    </div>
  );
}

export default SiteCardWithDetail;
